import React from 'react';
import { PlayCircle } from 'lucide-react';
import { getEmbedUrl, isDirectVideoFile } from '../../lib/embed';

/**
 * Public-facing video embed card. Renders YouTube/Vimeo iframe or HTML5 <video>.
 *
 * Props:
 *   url, title (used for iframe accessibility),
 *   testid (default 'profile-video-card')
 */
export default function VideoEmbedCard({ url, title = 'Video institucional', testid = 'profile-video-card' }) {
  if (!url) return null;
  const embed = getEmbedUrl(url);
  if (!embed) return null;
  const direct = isDirectVideoFile(url);
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6" data-testid={testid}>
      <h2 className="font-serif text-xl font-bold text-habita-dark flex items-center gap-2 mb-3">
        <PlayCircle className="w-5 h-5 text-habita" /> {title}
      </h2>
      <div className="relative aspect-video rounded-xl overflow-hidden bg-black">
        {direct ? (
          <video src={url} controls className="w-full h-full" preload="metadata" />
        ) : (
          <iframe
            src={embed}
            title={title}
            className="absolute inset-0 w-full h-full"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )}
      </div>
    </div>
  );
}
